export const CTR_BAR_CHART_OPTIONS = {
    chart: {
        stacked: true,
        toolbar: { show: false }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    grid: { show: true },
    legend: {
        show: true,
        horizontalAlign: 'center',
        position: 'top'
    },
    xaxis: {
        title: {
            text: 'Months',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: { show: true },
        categories: [
            '0', '1', '2', '3',
            '4', '5', '6', '7',
            '8', '9', '10'
        ]
    },
    yaxis: {
        title: {
            text: 'Total Reach',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            formatter: (value) => value,
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        }
    },
    dataLabels: { enabled: false },
    colors: ['#AD509E', '#E9BEE3'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4,
            columnWidth: '50px'
        }
    },
    tooltip: {
        y: {
            formatter: function (value) {
                return value+'%';
            }
        }
    }
};